import React, { useMemo, useState } from "react";
import { StepperFormViewer } from "../../stepper-form/StepperFormGenerator";
import { employeeBiodataFormJson } from "./employeebiodataform";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import { Transition } from "../../../Modal/ModalConstants";
import axios from "axios";
import { APP_BASE_URL, MCDO_EMPLOYEE_BIODATA } from "../../../Common/EndPoints";
import toast from "react-hot-toast";
import Loader from "../../Loader/Loader";
import { findDifferenceInArray } from "../helpers";

type IProps = {
  open: boolean;
  onClose: (byCross: boolean) => void;
  label: string;
  initialBioData: any;
  disableEditField?: boolean;
};

const EmployeeBiodataFormModal: React.FC<IProps> = ({
  open,
  onClose,
  label,
  initialBioData,
  disableEditField = true,
}) => {
  const [loading, setLoading] = useState(false);
  const handleSubmitEmployeeBiodataForm = async (values: any) => {
    try {
      setLoading(true);
      if (values.id) {
        if (disableEditField) {
          const [firstEle] = findDifferenceInArray([values, initialBioData]);
          if (!firstEle.difference) {
            toast.error("You have not changed any values. Please make a change before saving.");
            return;
          }
          await updateBiodataWithPatchReq(values);
        } else {
          await updateBioDataWithPutReq(values);
        }
      } else {
        await createBiodata(values);
      }
      onClose(false);
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        toast.error(error?.response?.data?.error?.message || "Something went wrong! Try again later!");
        return;
      }
      toast.error(error?.message || "Something went wrong! Try again later!");
    } finally {
      setLoading(false);
    }
  };

  const updateBiodataWithPatchReq = async (employeeBiodata: any) => {
    let url = `${APP_BASE_URL}${MCDO_EMPLOYEE_BIODATA}`;

    const res = await axios.patch(url, employeeBiodata, { params: { id: employeeBiodata.id } });
    toast.success("Bio data successfully updated");
  };

  const updateBioDataWithPutReq = async (employeeBiodata: any) => {
    let url = `${APP_BASE_URL}${MCDO_EMPLOYEE_BIODATA}`;

    const res = await axios.put(url, employeeBiodata, { params: { id: employeeBiodata.id } });
    toast.success("Bio data successfully changed");
  };

  const createBiodata = async (employeeBiodata: any) => {
    let url = `${APP_BASE_URL}${MCDO_EMPLOYEE_BIODATA}`;

    const res = await axios.post(url, employeeBiodata);
    toast.success("Bio data successfully added");
  };

  const employeeBiodataForm = useMemo(() => employeeBiodataFormJson(), []);

  return (
    <>
      <div>
        <Dialog
          fullScreen
          open={open}
          onClose={() => onClose(true)}
          aria-labelledby="responsive-dialog-title"
          TransitionComponent={Transition as any}
        >
          {loading && <Loader fullScreen={true} />}
          <DialogTitle id="responsive-dialog-title" className="flex">
            {label}
            <CloseIcon className="pointer" sx={{ ml: "auto" }} onClick={() => onClose(true)} />
          </DialogTitle>

          <DialogContent dividers>
            <StepperFormViewer
              disableEditField={disableEditField}
              submitForm={handleSubmitEmployeeBiodataForm}
              initForm={employeeBiodataForm}
              initialValue={initialBioData}
            />
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
};

export default EmployeeBiodataFormModal;
